/* Chic and Bling - product page.
   Builds one sticky bar that appears on small screens once the add-to-cart
   button scrolls out of view.

   SAFETY: this bar never submits anything. It scrolls to the personalisation
   step (or the buy button if Uploadly is absent) and moves focus there. A bar
   that added to cart directly would let a personalised order through without
   its photo - the same failure mode quick-add was disabled to prevent.

   Progressive enhancement: if this file fails, the page is unchanged. */
(function () {
  'use strict';

  /* Pull a currency amount out of the price block.
     Dawn renders BOTH a regular and a sale price container and hides one with
     CSS, and each contains a visually-hidden label such as "Regular price".
     Reading textContent would capture the label, and querySelector could pick
     the hidden container - so match the first currency amount instead and fall
     back to showing nothing. */
  function readPrice(scope) {
    var wrap = scope.querySelector('.price');
    if (!wrap) return '';
    var txt = (wrap.innerText || wrap.textContent || '').replace(/\s+/g, ' ');
    var m = txt.match(/[$£€¥][\d.,]+/);
    return m ? m[0] : '';
  }

  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var submit = info.querySelector('.product-form__submit');
    if (!submit) return;
    if (document.querySelector('.cb-sticky')) return;

    var titleEl = info.querySelector('h1');
    var target = info.querySelector('.shopify-app-block') || submit;
    var personalising = target !== submit;

    var bar = document.createElement('div');
    bar.className = 'cb-sticky';

    var meta = document.createElement('div');
    meta.className = 'cb-sticky__meta';

    var name = document.createElement('span');
    name.className = 'cb-sticky__name';
    name.textContent = titleEl ? titleEl.textContent.trim() : '';

    var price = document.createElement('span');
    price.className = 'cb-sticky__price';
    price.textContent = readPrice(info);

    meta.appendChild(name);
    meta.appendChild(price);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cb-sticky__btn';
    btn.textContent = personalising ? 'Personalise' : 'Buy options';
    btn.setAttribute(
      'aria-label',
      personalising
        ? 'Go to the personalisation step for this product'
        : 'Go to the buy options for this product'
    );

    btn.addEventListener('click', function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // move focus so keyboard and screen-reader users land there too
      var focusable = target.querySelector('input, select, textarea, button') || target;
      if (focusable.setAttribute && !focusable.hasAttribute('tabindex')) {
        focusable.setAttribute('tabindex', '-1');
      }
      if (focusable.focus) {
        setTimeout(function () { focusable.focus({ preventScroll: true }); }, 350);
      }
    });

    bar.appendChild(meta);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    /* Show only once the real button has left the viewport.
       The bar is hidden on desktop by CSS, not by JS, so resizing or rotating
       does the right thing without a reload. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            bar.classList.toggle('is-on', !e.isIntersecting);
          });
        },
        { threshold: 0 }
      ).observe(submit);
    }

    /* Variant changes re-render the price; keep the bar in step. */
    if ('MutationObserver' in window) {
      var priceHost = info.querySelector('.price');
      if (priceHost) {
        var pending = null;
        new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(function () {
            price.textContent = readPrice(info);
          }, 80);
        }).observe(priceHost, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
